import { gsap, ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

class TransformationAnim {
  constructor() {
    this.elements = document.querySelectorAll('.js-page-section');

    this.body = document.documentElement;
    this.items = gsap.utils.toArray('.about__pair');

    this.handleIntersection();
  }

  handleIntersection() {
    if (window.innerWidth > 768) {
      this.items.forEach(entry => {
        const itemLast = entry.querySelector('.about__pair__item--last');
        const itemLastWord = itemLast.querySelector('span');
        const itemFirst = entry.querySelector('.about__pair__item--first');
        const fromLabel = entry.querySelector('.about__pair__item__label');
        const itemGradient = entry.querySelector('.about__pair__gradient');
        const tl = gsap.timeline();

        gsap.config({
          nullTargetWarn: false,
        });

        tl.from(itemGradient, {
          duration: 1,
          opacity: 0,
          ease: 'power2.out',
          x: '-100%',
        })
          .to(itemGradient, {
            duration: 1,
            delay: -1,
            opacity: 1,
            ease: 'power2.out',
            x: '0%',
          })
          .from(itemLastWord, {
            duration: 1,
            delay: -1,
            x: '-100%',
            filter: 'blur(7px)',
            opacity: 0,
            ease: 'power2.out',
          })
          .to(itemLastWord, {
            duration: 1,
            delay: -1,
            x: '0%',
            filter: 'blur(0)',
            opacity: 1,
            ease: 'power2.out',
          })
          .from(itemFirst, {
            duration: 1,
            delay: -1,
            ease: 'power2.out',
          })
          .to(itemFirst, {
            duration: 1,
            delay: -1,
            opacity: 0.7,
            filter: 'blur(2px)',
            ease: 'power2.out',
          })
          .from(fromLabel, {
            duration: 1,
            delay: -1,
            ease: 'power2.out',
          })
          .to(fromLabel, {
            duration: 1,
            delay: -1,
            opacity: 0.7,
            filter: 'blur(1px)',
            ease: 'power2.out',
          });

        ScrollTrigger.create({
          animation: tl,
          trigger: entry,
          scrub: true,
          start: 'bottom bottom+=50',
          end: `bottom bottom-=250`,
        });
      });
    }
  }
}

export default TransformationAnim;
